import BybButtonChip from "@Components/common/byb-ds/buttons/byb-button-chip";
import { Theme, useTheme } from "@mui/material";
import { ReactNode } from "react";
import BybAnimatedBorder from "@Components/common/byb-ds/byb-animated-border";

interface IBybAnimatedPill {
  children: ReactNode;
  onClick?: () => void;
  color?: string;
}

const resolveColor = (theme: Theme, color?: string) => {
  return color ?? theme.palette.dsPurple?.v200 ?? theme.palette.dsSecondaryPurple.v200;
};

const BybAnimatedPill = ({ children, onClick, color }: IBybAnimatedPill) => {
  const theme = useTheme();
  const resolvedColor = resolveColor(theme, color);

  return (
    <BybAnimatedBorder borderRadius={theme.spacing(2.5)} borderWidth={1} color={resolvedColor}>
      <BybButtonChip
        onClick={onClick}
        sx={{
          backgroundColor: `${resolvedColor}1A`,
          border: `1px solid ${resolvedColor}28`,
          borderRadius: theme.spacing(2.5),
          padding: theme.spacing(1, 2),
          flexShrink: 0,
          minHeight: "unset",
          cornerShape: "unset",
          "& .MuiTypography-root": {
            color: resolvedColor,
            fontWeight: 500,
            fontSize: theme.typography.pxToRem(18),
            lineHeight: 1,
          },
          ":hover": {
            backgroundColor: `${resolvedColor}28`,
          },
        }}
      >
        {children}
      </BybButtonChip>
    </BybAnimatedBorder>
  );
};

export default BybAnimatedPill;
